import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, input, model } from '@angular/core';
import { Subscription } from 'rxjs';
import { ModalService } from 'src/app/core/services/modal.service';
import { AppButtonComponent } from '../app-button/app-button.component';
import { AppSelectInputComponent, SelectModel } from '../app-select-input/app-select-input.component';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CustomButtonDto } from '../app-button/app-button-dto';
import { WaveService } from 'src/app/core/services/wave.service';
import { AlertService, AlertType } from 'src/app/core/services/alert.service';
import { AppGuestModalComponent } from "../app-guest-modal/app-guest-modal.component";
import { AppSubstituteModalComponent } from "../app-substitute-modal/app-substitute-modal.component";
import { Router } from '@angular/router';
import { AppInputComponent, InputType } from "../app-input/app-input.component";
import { CommonModule } from '@angular/common';
import { ReplaceTextPipe } from '../../pipe/replace-text.pipe';
import { CustomCurrencyPipe } from '../../pipe/custom-currency.pipe';
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from '@angular/material/icon';
import { AppInfoModalComponent } from '../app-info-modal/app-info-modal.component';

declare var bootstrap: any;

@Component({
  selector: 'app-form-modal',
  standalone: true,
  imports: [
    CommonModule,
    AppButtonComponent,
    AppSelectInputComponent,
    ReactiveFormsModule,
    AppGuestModalComponent,
    AppSubstituteModalComponent,
    AppInfoModalComponent,
    AppInputComponent,
    ReplaceTextPipe,
    CustomCurrencyPipe,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './app-form-modal.component.html',
  styleUrl: './app-form-modal.component.scss'
})
export class AppFormModalComponent implements OnInit, OnDestroy {
  modalId = input.required<string>();
  modalTitle = input<string>('Modal de confirmação');
  modalBodyMessage = input<string>("");
  modalConfirmLabel = input<string>('');
  modalCancelLabel = input<string>('');
  showSelectInput = input<boolean>(true);
  showCloseBtn = input<boolean>(true);
  isSenior = input<boolean>(true);
  isAtLeast12 = input<boolean>(true);
  isCanceled: boolean;
  openCheckin: boolean;
  openSubstitute: boolean;
  isLoginDependente: any = localStorage.getItem('isDependent') === 'true';

  InputTypeEnum = InputType;

  guestData: any;
  substituteData: any;

  selectControl = input<FormControl>(new FormControl());
  ticketControl = input<FormControl>(new FormControl());
  emailControl = input<FormControl>(new FormControl());
  isDependent = false;
  isGuest = false;
  isSubstitute = false;

  socioAfterLimit = false;
  dependentAfterLimit = false;
  guestAfterLimit = false;
  needEmailDep = false;
  hasCheckin = false;

  @Input() selectInputLabel: string;
  @Input() checkinSelected: any;
  @Input() selectInputOptions: SelectModel[];
  @Input() ticketData: any;
  @Input() checkinsHistory: any;
  @Input() limitCheckin: any;
  @Input() memberDependents: any;

  waveSelect: any;

  ticketsOptions: any[] = [];
  substituteTaxes: any[] = [];
  checkinTaxes: any[] = [];
  taxSelected: any;
  modalInstance: any;

  @Output() onModalConfirm = new EventEmitter();

  confirmAction = model<boolean | FormControl>(false);

  private modalSubscription: Subscription | undefined;

  cancelBtn = {
    buttonText: 'Cancelar',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm px-5 py-2 btn-secondary',
  };

  confirmBtn = {
    buttonText: 'Confirmar Check-in',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm px-5 py-2 btn-primary',
    btnDisabledBackground: '#f2e2b2',
    btnDisabledTextColor: '#000000'
  };

  guestBtn = {
    buttonText: 'Adicionar Convidado',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm px-5 py-2 btn-secondary',
    btnDisabledBackground: '#f2e2b2',
    btnDisabledTextColor: '#000000'
  }

  substituteBtn = {
    buttonText: 'Adicionar Substituto',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm px-5 py-2 btn-secondary',
    btnDisabledBackground: '#f2e2b2',
    btnDisabledTextColor: '#000000'
  }

  visualizarOptions = {
    buttonText: 'Visualizar',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm px-2 btn-primary',
  } as CustomButtonDto;

  cancelarOptions = {
    buttonText: 'Cancelar',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm px-2 btn-secondary',
  } as CustomButtonDto;

  modalInfoTitle = `Taxa de Substituição`;

  modalInfoMessage = `
    Alguns ingressos possuem uma taxa de substituição para troca de titularidade.
    <br><br>
    Essa taxa é definida conforme o tipo de ingresso adquirido.
    <br><br>
    Caso tenha dúvidas, entre em contato com o nosso suporte.
  `;

  constructor(
    private modalService: ModalService,
    private waveService: WaveService,
    private router: Router,
    private alertService: AlertService,
    private replaceTextPipe: ReplaceTextPipe,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.modalSubscription = this.modalService.modalState$.subscribe((state) => {
      if (state.id === 'modalCheckinTicket') {
        const modalElement = document.getElementById('modalCheckinTicket');
        if (modalElement) {

          if (state.action === 'open') {
            this.modalInstance = new bootstrap.Modal(modalElement); // Instanciando o modal
            this.modalInstance.show();
            modalElement.addEventListener('hidden.bs.modal', () => {
              this.resetModal();
            });
            setTimeout(() => {
              this.waveSelect = this.ticketData.find((i: any) => i.id === this.checkinSelected);
              this.substituteTaxes = [...this.waveSelect.substituteTaxes];
              this.checkinTaxes = [...this.waveSelect.checkinTaxes];
              this.alterarTickets();
              this.setStatus();
              this.validHasSubstitute();
              this.validLimitsCheckin();
              this.selectControl().setValue(this.selectInputOptions[0]?.code);
              this.cdr.detectChanges();
            }, 200);
          } else if (state.action === 'close') {
            if (this.modalInstance) {
              this.modalInstance.hide();
            }
          }
        }
      }
    });

    this.setBtnLabel();
    this.ticketControl().disable();
  }


  openGuestModal(): void {
    this.modalService.open('modalGuest');
  }

  openSubstituteModal(): void {
    this.modalService.open('modalSubstitute');
  }

  openInfoModal(): void {
    this.modalService.open('modalInfo');
  }

  validAssociateCheckin(): boolean {
    let hasAssociateCheckin = this.checkinsHistory.find((c: any) => c.checkinStatus.includes('Realizado') && c.isDependent == false && c.isGuest == false);
    if (hasAssociateCheckin) {
      return false;
    }

    return true;
  }

  validLimitsCheckin(): void {
    const waveSelect = { ...this.waveSelect };
    if (this.limitCheckin.limitChechin !== null && this.limitCheckin.limitChechin > 0 && this.limitCheckin.limitChechinUsed >= this.limitCheckin.limitChechin) {
      if (waveSelect?.waveTicketsAfterLimitSocio.length > 0 && waveSelect?.waveTicketsAfterLimitSocio !== null) {
        this.socioAfterLimit = true;
      } else {
        this.alertService.showAlert(
          AlertType.INFO,
          this.replaceTextPipe.transform("Você atingiu o limite de checkins para sócios nesse plano")
        );
        let associateIndex = this.selectInputOptions.findIndex((a: any) =>
          a.name.includes('Sócio')
        );
        if (associateIndex !== -1) {
          this.selectInputOptions.splice(associateIndex, 1);
        }
      }

    }
    if (this.limitCheckin.limitDependentCheckin > 0 && this.limitCheckin.limitDependentCheckin !== null && this.limitCheckin.limitDependentCheckin <= this.limitCheckin.limitDependentCheckinUsed) {
      if (waveSelect?.waveTicketsAfterLimitDependent.length > 0 && waveSelect?.waveTicketsAfterLimitDependent != null) {
        this.dependentAfterLimit = true;
      } else {
        this.alertService.showAlert(
          AlertType.INFO,
          this.replaceTextPipe.transform("Você atingiu o limite de checkins para dependentes nesse plano")
        );
        this.selectInputOptions = this.selectInputOptions.filter(option => {
          return !option.name.includes('Dependente');
        });
      }
    }
    if (this.limitCheckin.limitGuestCheckin > 0 && this.limitCheckin.limitGuestCheckin !== null && this.limitCheckin.limitGuestCheckin <= this.limitCheckin.limitGuestCheckinUsed) {
      if (waveSelect?.waveTicketsAfterLimitGuest.length > 0 && waveSelect?.waveTicketsAfterLimitGuest != null) {
        this.guestAfterLimit = true;
      } else {
        this.alertService.showAlert(
          AlertType.INFO, this.replaceTextPipe.transform("Você atingiu o limite de checkins para convidados nesse plano")
        );
        this.selectInputOptions = this.selectInputOptions.filter(option => {
          return !option.name.includes('Convidado');
        });
      }
    }
  }

  validHasSubstitute(): void {
    let hasSubstituteCheckin = this.checkinsHistory.find((c: any) =>
      c.checkinStatus.includes('Realizado') && c.isSubstitute === true
    );

    if (hasSubstituteCheckin) {
      let associateIndex = this.selectInputOptions.findIndex((a: any) =>
        a.name.includes('Sócio')
      );

      if (associateIndex !== -1) {
        this.selectInputOptions.splice(associateIndex, 1);
      }
    }
  }


  closeModal() {
    this.resetModal();
    if (this.modalInstance) {
      try {
        this.modalInstance.hide();
      }
      catch (error) {
        console.error(error);
      }
    }
  }

  resetModal() {
    this.selectControl().reset();
    this.ticketControl().reset();
    this.ticketControl().disable();
    this.emailControl().reset();
    this.ticketsOptions = [];
    this.isDependent = false;
  }

  setBtnLabel(): void {
    if (this.modalCancelLabel() !== '')
      this.cancelBtn.buttonText = this.modalCancelLabel();
    if (this.modalConfirmLabel() !== '')
      this.confirmBtn.buttonText = this.modalConfirmLabel();
  }

  ngOnDestroy(): void {
    if (this.modalSubscription) {
      this.modalSubscription.unsubscribe();
    }
  }

  cancelarCheckin(checkin: any) {
    this.waveService.cancelCheckin(checkin.id, checkin.orderId).subscribe({
      next: (res: any) => {
        this.closeModal();
        this.alertService.showAlert(AlertType.SUCCESS, 'Checkin cancelado com sucesso.');
        window.location.reload();
      }, error: (error) => {
        console.error('Error loading data:', error);
      }
    })

  }

  validGuestLimit(): boolean {
    const limit = this.waveSelect.guestLimit;
    let count = this.checkinsHistory.filter((c: any) => c.checkinStatus.includes('Realizado') && c.isGuest == true);

    if (count.length >= limit || !this.limitCheckin.permitGuestTicket) {
      return false;
    }

    if (this.limitCheckin.permitGuestTicket && this.limitCheckin.limitGuestCheckin > 0 && this.limitCheckin.limitGuestCheckin !== null && this.limitCheckin.limitGuestCheckin <= this.limitCheckin.limitGuestCheckinUsed) {
      return false;
    }

    return true;
  }

  visualizarCheckin(checkin: any) {
    if (this.waveSelect.waveGame.ticketsApiType.id === '2649821c-02d2-407e-9cf5-0a1741a9ec37') {
      this.router.navigate(['/check-in/detalhe/' + checkin.orderId], { state: { checkin: checkin, game: this.waveSelect } });
    } else {
      window.open(checkin.ticketLink, '_blank');
    }
  }

  getTicketById(checkin: any) {
    const waveSelect = { ...this.waveSelect };
    if (checkin.memberDependentName) {
      return waveSelect.waveTicketsDependent.find((i: any) => i.id === checkin.ticket)?.ticketName
    } else if (checkin.memberGuestName) {
      return waveSelect.waveTicketsGuest.find((i: any) => i.id === checkin.ticket)?.ticketName
    } else if (!this.isAtLeast12) {
      return waveSelect.waveTicketsMinors.find((i: any) => i.id === checkin.ticket)?.ticketName
    } else if (this.isSenior()) {
      return waveSelect.waveTicketsSeniors.find((i: any) => i.id === checkin.ticket)?.ticketName
    }
    else {
      return waveSelect.waveTicketsSocio.find((i: any) => i.id === checkin.ticket)?.ticketName
    }
  }

  setStatus() {
    this.isCanceled = this.waveSelect.isCancel;
    this.openCheckin = this.waveSelect.openCheckin;
    this.openSubstitute = this.waveSelect.openSubstitute;
  }

  alterarTickets() {
    this.needEmailDep = false;
    this.hasCheckin = false;
    this.emailControl().reset();
    const waveSelect = { ...this.waveSelect };

    let clientSelect = this.selectInputOptions.find(i => i.code === this.selectControl()?.value);
    if (clientSelect) {
      this.ticketControl().enable();
    }

    this.ticketsOptions = [];

    // Preenche as opções de ingressos com base no tipo de cliente
    if (clientSelect?.name.includes('Sócio')) {
      this.isDependent = false;
      this.isGuest = false;
      this.isSubstitute = false;

      const checkinMember = this.checkinsHistory.find((c: any) => c.checkinStatus.includes('Realizado') && c.isDependent == false && c.isGuest == false);
      if (checkinMember) {
        this.hasCheckin = true;
      }

      if (this.isSenior()) {
        waveSelect.waveTicketsSeniors.forEach((t: any) => {
          let ti: SelectModel = { code: t.ticketId, name: t.ticketName };
          this.ticketsOptions.push(ti);
        });
      } else if (!this.isAtLeast12()) {
        waveSelect.waveTicketsMinors.forEach((t: any) => {
          let ti: SelectModel = { code: t.ticketId, name: t.ticketName };
          this.ticketsOptions.push(ti);
        });
      } else if (this.socioAfterLimit) {
        waveSelect.waveTicketsAfterLimitSocio.forEach((t: any) => {
          let ti: SelectModel = { code: t.ticketId, name: t.ticketName };
          this.ticketsOptions.push(ti);
        });
      } else {
        waveSelect.waveTicketsSocio.forEach((t: any) => {
          let ti: SelectModel = { code: t.ticketId, name: t.ticketName };
          this.ticketsOptions.push(ti);
        });
      }
    } else if (clientSelect?.name.includes('Substituto') && waveSelect?.waveTicketsSocio.length > 0) {
      this.isDependent = false;
      this.isGuest = false;
      this.isSubstitute = true;

      const checkinSubstitute = this.checkinsHistory.find((c: any) => c.checkinStatus.includes('Realizado') && c.isSubstitute === true);
      if (checkinSubstitute) {
        this.hasCheckin = true;
      }

      const tickets = this.socioAfterLimit ? waveSelect.waveTicketsAfterLimitSocio : waveSelect.waveTicketsSocio;

      tickets.forEach((t: any) => {
        let ti: any = { code: t.ticketId, name: t.ticketName };
        this.ticketsOptions.push(ti);
      });

    } else if (clientSelect?.name.includes('Dependente') && waveSelect?.waveTicketsDependent.length > 0) {
      this.isDependent = true;
      this.isGuest = false;
      this.isSubstitute = false;

      const checkinDependent = this.checkinsHistory.find((c: any) =>
        c.checkinStatus.includes('Realizado') &&
        c.isDependent === true &&
        c.memberDependentId === this.selectControl().value
      );
      if (checkinDependent) {
        this.hasCheckin = true;
      }

      this.validDependentHasEmail(clientSelect);

      if (this.dependentAfterLimit) {
        waveSelect.waveTicketsAfterLimitDependent.forEach((t: any) => {
          let td: SelectModel = { code: t.ticketId, name: t.ticketName };
          this.ticketsOptions.push(td);
        });
      } else {
        waveSelect.waveTicketsDependent.forEach((t: any) => {
          let td: SelectModel = { code: t.ticketId, name: t.ticketName };
          this.ticketsOptions.push(td);
        });
      }
    } else if (clientSelect?.name.includes('Convidado') && waveSelect?.waveTicketsGuest.length > 0) {
      this.isDependent = false;
      this.isGuest = true;
      this.isSubstitute = false;

      const checkinGuest = this.checkinsHistory.find((c: any) => c.checkinStatus.includes('Realizado') && c.isGuest === true && c.memberGuestId === this.selectControl().value);
      if (checkinGuest) {
        this.hasCheckin = true;
      }

      if (this.guestAfterLimit) {
        waveSelect.waveTicketsAfterLimitGuest.forEach((t: any) => {
          let td: SelectModel = { code: t.ticketId, name: t.ticketName };
          this.ticketsOptions.push(td);
        });
      } else {
        waveSelect.waveTicketsGuest.forEach((t: any) => {
          let td: SelectModel = { code: t.ticketId, name: t.ticketName };
          this.ticketsOptions.push(td);
        });
      }
    }

    // Adiciona a opção "Selecione o ingresso" como a primeira entrada
    this.ticketsOptions.sort((a, b) => a.name.localeCompare(b.name));
    this.ticketsOptions.unshift({ code: 'default', name: 'Selecione o ingresso' });
    // Define a opção padrão como selecionada
    this.ticketControl().setValue('default');
  }

  onChangeTicket(ticketId: string) {
    if (this.isSubstitute) {
      this.taxSelected = this.substituteTaxes.find(t => t.ticket.ticketId === ticketId) || null;
    } else {
      this.taxSelected = this.checkinTaxes.find(t => t.ticket.ticketId === ticketId) || null;
      this.modalInfoMessage = `
        Alguns ingressos possuem taxa para realizar o checkin.
        <br><br>
        Essa taxa é definida conforme o tipo de ingresso adquirido.
        <br><br>
        Caso tenha dúvidas, entre em contato com o nosso suporte.
      `;
      this.modalInfoTitle = `Taxa de Checkin`;
    }
  }

  validDependentHasEmail(dep: any) {
    const dependent = this.memberDependents?.content?.find((d: any) => d.id === dep.code);
    if (dependent && !dependent.email) {
      this.needEmailDep = true;
    }
  }

  onModalGuestConfirm(event: any) {
    let option: SelectModel = {
      code: '1',
      name: `${event.nameControl} (Convidado)`
    }
    this.selectInputOptions.push(option);
    this.alertService.showAlert(AlertType.SUCCESS, 'Dados do convidado adicionados! Para finalizar confirme o check-in.');
    this.selectControl().setValue(option.code);
    this.guestData = event;
  }

  onModalSubstituteConfirm(event: any) {
    let option: SelectModel = {
      code: '1',
      name: `${event.nameControl} (Substituto)`
    }
    this.selectInputOptions.push(option);
    this.alertService.showAlert(AlertType.SUCCESS, 'Dados do substituto adicionados! Para finalizar confirme o check-in.');
    this.selectControl().setValue(option.code);
    this.substituteData = event;
  }

  validForm(): boolean {
    if (
      this.selectControl().value == null ||
      this.ticketControl().value == null ||
      this.ticketControl().value === 'default'
    ) {
      return false;
    }

    if ((this.emailControl().value == null || this.emailControl().value == '') && this.needEmailDep) {
      return false;
    }

    return !this.hasCheckin;
  }

  onConfirm() {
    if (this.selectControl().value == null || this.ticketControl().value == null) {
      this.alertService.showAlert(AlertType.WARNING, 'Preencha as informações antes de confirmar!');
    } else {
      const dataConfirm: any = {
        clientSelected: this.selectControl().value,
        ticketSelected: this.ticketControl().value,
        emailDependent: this.emailControl().value,
        isDependent: this.isDependent,
        isGuest: this.isGuest,
        guestData: this.guestData,
        isSubstitute: this.isSubstitute,
        substituteData: this.substituteData,
        substituteTax: this.taxSelected,
        checkinTax: this.taxSelected
      }
      this.onModalConfirm.emit(dataConfirm);
      this.modalInstance.hide();
    }
  }
}
